<script>
	import Config from '../../Models/Config';
	import Helper from '../../Models/Helper';
	import Trigger from '../../Models/Trigger';

	Trigger.subscribe('authentication', state => {
		if (!state.active) {
			const message = Config.labels.sign_out.success;
			Trigger.event('alert', {icon: 'comment', message});
		}
	});
</script>